/**Import react section */
import React from 'react'
import PropTypes from 'prop-types'
import { PhotoProvider, PhotoView } from 'react-photo-view'
import 'react-photo-view/dist/react-photo-view.css'
/**Import material section */
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline'
import Checkbox from '@material-ui/core/Checkbox'
import RefreshIcon from '@material-ui/icons/Refresh'
/**Import helpers section */
import { convertUrlImg } from '../ImageHelpper'
/**Import styles section */
import { ImageStyles } from './ImageStyles'

const ImageVisualizer = (props) => {
	/**array props sections */
	const { images, selectedImages = [], onSelectImage= () => {} } = props
	/**Bool props sections */
	const { canBeDelete, isLoadingDeleteImages } = props
	/**function props sections */

	const classes = ImageStyles()
	return (
		<div style={{ marginTop: '1rem' }}>
			<PhotoProvider
				toolbarRender={({ onScale, scale, rotate, onRotate }) => (
						<>
							<RefreshIcon onClick={() => onRotate(rotate + 90)} />
							<AddCircleOutlineIcon onClick={() => onScale(scale + 1)} />
							<RemoveCircleOutlineIcon onClick={() => onScale(scale - 1)} />
						</>
					)}
			>
				<div style={{ display: 'flex', flexWrap: 'wrap' }}>
						{images.map((image, index) => (
							<div className={classes.imageBlock} key={index}>
								{canBeDelete && (
									<Checkbox
										checked={selectedImages.includes(image)}
										onChange={() => onSelectImage(image)}
										color="primary"
										className={classes.deleteButon}
										disabled={isLoadingDeleteImages}
									/>
								)}
						<PhotoView key={index} src={convertUrlImg(image)}>
							<img src={convertUrlImg(image)} alt='attachment' className={classes.image} />
						</PhotoView>
						</div>
					))}
				</div>
			</PhotoProvider>
			</div>
	)}

ImageVisualizer.propTypes = {
	images: PropTypes.array.isRequired,
	canBeDelete: PropTypes.bool,
    isLoadingDeleteImages: PropTypes.bool,
    selectedImages: PropTypes.array,
    onSelectImage: PropTypes.func,
    onDeleteEvidence: PropTypes.func
}
ImageVisualizer.defaultProps = {
    canBeDelete: false,
    isLoadingDeleteImages: false,
    selectedImages: [],
    onSelectImage: () => {},
    onDeleteEvidence: () => {}
}
export default ImageVisualizer
